import { PriorityFilterValue } from '@hakimo-ui/hakimo/types';
import { MultiSelect } from '@hakimo-ui/hakimo/ui-elements';

interface PriorityFilterProps {
  value: PriorityFilterValue | undefined;
  onChange: (value: PriorityFilterValue) => void;
  options: Array<{ id: string; name: string }>;
}

export function PriorityFilter({
  value,
  onChange,
  options,
}: PriorityFilterProps) {
  const selectableOptions = options.map((option) => ({
    id: option.id,
    name: option.name,
  }));

  const selectedOptions = selectableOptions.filter(
    (option) => value?.values?.includes?.(option.name) ?? false
  );

  const handlePriorityChange = (selected: typeof selectableOptions) => {
    onChange({
      values: selected.map((option) => option.name),
      negative: value?.negative ?? false,
    });
  };

  return (
    <MultiSelect
      label="Priority"
      value={selectedOptions}
      onChange={handlePriorityChange}
      getItems={(query: string) =>
        selectableOptions.filter((option) =>
          option.name.toLowerCase().includes(query.toLowerCase())
        )
      }
      displayValue={(item) => item?.name ?? ''}
      id={(item) => item?.id ?? ''}
    />
  );
}

export default PriorityFilter;
